import { Component, OnInit, ViewChild } from "@angular/core";
import { IXSModalComponent } from "../../../components/ixsmodal/ixsmodal.component";
import { SMStudentinfoService } from "../../forms/school-management/transaction/studentprofile/studentprofile.service";
import { GenEnum } from "../../shared/general.enum";
import { NavModalComponent } from "../../../core/component/NavModal.Component";
import { SMBlockactivityService } from "../../forms/school-management/transaction/blockactivity/blockactivity.service";

@Component({
  selector: "app-parentnavbar",
  templateUrl: "./parentnavbar.component.html",
  styleUrls: ["./parentnavbar.component.css"],
})
export class ParentnavbarComponent extends NavModalComponent<any> {
  protected localStorage: any;

  today: number = Date.now();
  time: Date;

  localdata = {
    clientstxt: JSON.parse(this.localStorage.get("stdinfo")),
    username: this.localStorage.get("User"),
    fullname: this.localStorage.get("Fullname"),
    userpic: this.localStorage.get("Guradianimage"),
    localurl: this.localStorage.get("OnlyUrl"),
    utuser: this.localStorage.get("utuser"),
  };
  model: any = {};
  studentlist: any;
  schoolname: any;
  studentcount: any;

  @ViewChild("changepass") changepass: IXSModalComponent;

  getCurrenDate() {
    setInterval(() => {
      var d = new Date(); // for now
      this.LookupData.time = d.toLocaleTimeString();
    }, 1000);
  }

  constructor(
    private studentService: SMStudentinfoService,
    private blockactivityservice: SMBlockactivityService
  ) {
    super(studentService);
  }
  async ngOnInit() {
    await this.getstudlist();
    this.model.userclients = localStorage.getItem("userclients");
    this.localdata.clientstxt.entitystxt;

    this.getCurrenDate();
  }

  async modalInitialize() { }

  logout() {
    this.localStorage.clear();
    this.navigate("/login");
  }

  async changepassword() {
    this.changepass.customOpen("md");
  }

  async getstudlist() {
    if (
      this.studentService.ChildList &&
      this.studentService.ChildList.length &&
      this.studentService.ChildList.length > 0
    ) {
      this.studentlist = this.studentService.ChildList;
      if (this.studentlist) {
        this.studentcount = this.studentlist.length;
      }

      this.studentlist.forEach((e) => {
        e.filepath =
          this.localdata.localurl + GenEnum.Image.imageUrl + e.filepath;
      });
    } else {
      let userObj = JSON.parse(this.localdata.utuser);
      await this.studentService.getChildList(userObj.empid);
      this.studentlist = this.studentService.ChildList;

      if (this.studentlist) {
        this.studentcount = this.studentlist.length;
      }

      this.studentlist.forEach((e) => {
        e.filepath =
          this.localdata.localurl + GenEnum.Image.imageUrl + e.filepath;
      });
    }
  }

  async switchstudnt(e) {
    this.startLoading();
    if (e) {
      
      const dto = await this.blockactivityservice.GetBlockactivity(e.Id, GenEnum.ComplainerType.Student);

      if (dto && dto.Data) {
        let blockactivitydata = dto.Data;
        this.localStorage.set("blkactivity", JSON.stringify(blockactivitydata));
      }
      let studinfo = {
        Courseid: e.courseid,
        Sectionid: e.sectionid,
        Id: e.Id,
        entitystxt: e.OrgLegalentity.stxt,
      };
      this.localStorage.set("stdinfo", JSON.stringify(studinfo));
      this.localStorage.set("Studentid", JSON.stringify(e.Id));

      window.location.reload();
      this.stopLoading();
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/parentnavbar/parentnavbar.component.ts